export default __webpack_public_path__ + "static/media/vitamin-d.1fba8d62.jpg";